// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3vypQ","inputWrap":"Table_inputWrap__1Xx3C","col":"Table_col__2xjDC","bmiTooltip":"Table_bmiTooltip__1siLu"};